module.exports = "/images/SouthAfrica.png?052cad5d50c899cc31ce2c15c3999086";